const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const CLASSIFIER_URL = process.env.REACT_APP_CLASSIFICATION_URL || 'http://23.20.180.218:5000';
const POS_SERVER_TOKEN = process.env.REACT_APP_POS_SERVER_TOKEN || 'pos_server'
const CB_URL = process.env.REACT_APP_CLICKBACON_URL
const CB_TOKEN = process.env.REACT_APP_CLICKBACON_TOKEN
export { API_URL, CLASSIFIER_URL, POS_SERVER_TOKEN, CB_URL, CB_TOKEN };